export default __webpack_public_path__ + "static/media/Newsletter 023.0bd5a79e.png";